import { FC, useMemo } from 'react';
import ReactSelect, { SelectOption } from '@components/atoms/ReactSelect';
import { getTimezoneOptions } from '@constants/timezones';

interface TimezoneSelectProps {
  value: string | null | undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/** Sprint 33, story-169 (D15). `Intl.supportedValuesOf('timeZone')` when available, else the
 * curated fallback list. */
export const TimezoneSelect: FC<TimezoneSelectProps> = ({ value, onChange, disabled }) => {
  const options: SelectOption[] = useMemo(
    () => getTimezoneOptions().map((tz) => ({ value: tz, label: tz.replace(/_/g, ' ') })),
    [],
  );

  const selected = options.find((o) => o.value === value) ?? null;

  return (
    <ReactSelect
      options={options}
      value={selected}
      isDisabled={disabled}
      isSearchable
      onChange={(option) => {
        const next = option as SelectOption | null;
        if (next) onChange(String(next.value));
      }}
    />
  );
};

export default TimezoneSelect;
